import http from './http'
import moment from 'moment'

/*
 * Products
 */
export function syncProducts (salesChannelKey) {
  return http.post(`/sales-channels/${salesChannelKey}/import-products`)
}
export function getProduct (id, params) {
  return http.get(`/products/${id}`, { params })
}
export function removeProduct (id) {
  return http.delete(`/products/${id}`)
}

/*
 * Orders
 */
export function getOrder (id, params) {
  return http.get(`/orders/${id}`, { params })
}

export function getOrderNotification () {
  return http.get(`/order-notification`)
}

export function syncAllOrders () {
  return http.post(`/sales-channels/import-orders`)
}

export function syncOrders (salesChannelKey) {
  return http.post(`/sales-channels/${salesChannelKey}/import-orders`)
}

export function syncRefunds (salesChannelKey) {
  return http.post(`/sales-channels/${salesChannelKey}/import-refunds`)
}

export function syncStocks (salesChannelKey) {
  return http.post(`/sales-channels/${salesChannelKey}/sync-stocks`)
}

export function getOrders (params) {
  return http.get(`/orders`, { params })
}

export function getOrderReport (params) {
  return http.get(`/report-orders`, { params })
}

export function getOrderReportTotals (params) {
  return http.get(`/report-orders-totals`, { params })
}

export function getRefunds (params) {
  return http.get(`/refunds`, { params })
}

export function getRefund (id, params) {
  return http.get(`/refunds/${id}`, { params })
}

export function getHourRegistrations (id, params) {
  return http.get(`/hour-registrations/${id}`, { params })
}

export function getOrderLists (params) {
  return http.get(`/order-list`, { params })
}

export function getOrderList (id, params) {
  return http.get(`/order-list/${id}`, { params })
}

export function getOrderNumbers (params) {
  return http.get(`/orders`, { params })
    .then(orders => orders.data.data.map(o => o.number))
}

export function changeOrderStatus (orderNumbers, status) {
  const params = {
    'filter[number]': orderNumbers
  }

  return http.patch(`/orders`, { status }, { params })
}

export function createShipment (data) {
  return http.post('/shipments', data)
}

export function getShippingCosts () {
  return http.get(`/shipping-costs`)
}

export function getBarcodeScanners () {
  return http.get('/barcode-scanners')
}

export function getSalesChannelCommissions () {
  return http.get(`/sales-channels-commission`)
}

export function printLabel (id) {
  return http.post(`/shipments/${id}/print`)
}

export function printInvoices (orderNumbers) {
  const params = {
    'orders': orderNumbers
  }

  return http.post('/invoices/print', null, { params })
}

export function getJobs () {
  const params = {
    'filter[status]': 'executing,queued,finished',
    'filter[finished_after]': moment().subtract(8, 's').format()
  }

  return http.get('/jobs', { params })
    .then(response => response.data)
}



// WEBPACK FOOTER //
// ./src/utils/api.js